import { LitElement, classMap, css, html } from '@lit'

class NovaWishlistButton extends LitElement {
  static properties = {
    _active: {
      state: false,
    },
  }

  onClick(e) {
    e.preventDefault()

    this._active = !this._active
  }

  render() {
    return html` <div
      class=${classMap({ 'is-active': this._active })}
      @click=${this.onClick}
    >
      <slot></slot>
    </div>`
  }

  static styles = css`
    :host {
      width: 25px;
      height: 25px;
      display: block;
      position: absolute;
      top: 1em;
      right: 1em;
      z-index: 2;
    }
    :host(:hover) {
      cursor: pointer;
    }
    ::slotted(svg) {
      transition: fill var(--nova-transition, 400ms) ease;
      fill: white;
    }
    .is-active ::slotted(svg) {
      fill: red;
    }
  `
}

customElements.define('nova-wishlist-button', NovaWishlistButton)
